import React from 'react'

export const ArrowRightCircle = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g clip-path="url(#clip0_5021_62911)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.0045 7.75759C11.614 8.14811 11.614 8.78128 12.0045 9.1718L13.8327 10.9999H7.75732C7.20503 10.9999 6.75732 11.4477 6.75732 11.9999C6.75732 12.5522 7.20503 12.9999 7.75732 12.9999H13.8332L12.0045 14.8287C11.614 15.2192 11.614 15.8524 12.0045 16.2429C12.395 16.6334 13.0282 16.6334 13.4187 16.2429L16.9543 12.7074C17.3448 12.3168 17.3448 11.6837 16.9543 11.2931L13.4187 7.75759C13.0282 7.36706 12.395 7.36706 12.0045 7.75759Z" fill="#04A6A2" />
    </g>
    <defs>
      <clipPath id="clip0_5021_62911">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
